<button class="btn btn-secondary"
        (click)="openHelpCenter()"
        [disabled]="loading"
        attr.aria-label="{{'Go to help center' | translate}}">
        <mon-icon [icon]="['HELPCENTER', 'ICON']"></mon-icon>
</button>
